import { render, staticRenderFns } from "./EventFormInsert.vue?vue&type=template&id=70f757c0"
import script from "./EventFormInsert.vue?vue&type=script&lang=js"
export * from "./EventFormInsert.vue?vue&type=script&lang=js"
import style0 from "./EventFormInsert.vue?vue&type=style&index=0&id=70f757c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports